import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_AUDIT_GROUPS = "GET_AUDIT_GROUPS";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Admin/GetAuditGroupList/true/New Audit Setup/false/` + (data.eaAuditId ?? 0),
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_AUDIT_GROUPS, service, mock);
